<template>
  <div class="hello">

      <transition name="fade">
            <div v-if="loadingPage" class="loading">
                <p>Loading...</p>
            </div>
        </transition>

    <b-container>
        <b-row>
            <b-col>
                <h1 style="text-align:center; margin-top:20px; margin-bottom:20px">{{theSaleItem.title}}</h1>
            </b-col>
        </b-row>
        <!-- Images carousel -->
        <carousel :autoplay="false" :perPage="1" :navigationEnabled="true" >
            <!-- Image 1 -->
            <slide v-if="theSaleItem.imageurl1">
                <div style="text-align:center">
                    <img :src="theSaleItem.imageurl1" width="250"  fluid alt="Logo image" >
                </div>
            </slide>
            <!-- Image 2 -->
            <slide v-if="theSaleItem.imageurl2">
                <div style="text-align:center">
                    <img :src="theSaleItem.imageurl2" width="250"  fluid alt="Logo image" >
                </div>
            </slide>
            <!-- Image 3 -->
            <slide v-if="theSaleItem.imageurl3">
                <div style="text-align:center">
                    <img :src="theSaleItem.imageurl3" width="250"  fluid alt="Logo image" >
                </div>
            </slide>
            <!-- Image 4 -->
            <slide v-if="theSaleItem.imageurl4">
                <div style="text-align:center">
                    <img :src="theSaleItem.imageurl4" width="250"  fluid alt="Logo image" >
                </div>
            </slide>
            <!-- Image 1 -->
            <slide v-if="theSaleItem.imageurl5">
                <div style="text-align:center">
                    <img  :src="theSaleItem.imageurl5" width="250"  fluid alt="Logo image" >
                </div>
            </slide>
            <!-- Image 1 -->
            <slide v-if="theSaleItem.imageurl6">
                <div style="text-align:center">
                    <img  style="cursor: pointer;" :src="theSaleItem.imageurl6" width="175"  fluid alt="Logo image" >
                </div>
            </slide>
        </carousel>
        <b-row>
            <b-col>
                <div style="margin-bottom:20px"> {{theSaleItem.description}}</div>
            </b-col>
        </b-row>

        <!-- Price -->
        <b-row>
            <b-col>
                <h3 style="color:green">$ {{theSaleItem.price}}</h3>
            </b-col>
        </b-row>

        <!-- Company -->
        <b-row>
            <b-col>
                <h3>Sold By: {{theSaleItem.company}}</h3>
            </b-col>
        </b-row>

        <!-- Location -->
        <b-row>
            <b-col>
                <h4>Location: {{theSaleItem.city}}, {{theSaleItem.state}}</h4>
            </b-col>
        </b-row>

        <!-- Sign in, if no user -->
        <b-row v-if='!currentUser'>
            <b-col>
                <b-button size="lg" class="m-md-2" variant="info" @click="$router.push('/createaccount')">
                    Join Kegseeker to connect with the seller
                </b-button>
            </b-col>
        </b-row>

        <!-- Send a message -->
        <b-button v-if="currentUser" @click="sendMessageModalVisible=true" size="lg" variant="info"
            >Send a Mesage <i><font-awesome-icon icon="comment" /></i>
        </b-button>
            <b-modal size="xl" v-model="sendMessageModalVisible" no-fade :id="'SendMsg' + theSaleItem.id" title="Send a Message"  hide-footer>
                <div>
                    <sendmessage  :receiverId="theSaleItem.uid" :receiverName="theSaleItem.company"  :arrayDefaultMessages="arrayDefaultMessages"/>
                </div>
        </b-modal>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { Carousel, Slide } from 'vue-carousel';
import Sendmessage from '../Sendmessage'
const fb = require('../../firebaseConfig.js')

export default { 
    props: [],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'selectedSaleItem'])
    },

    components: {
        Carousel,
        Slide,
        Sendmessage,
    },

    data() {
        return {
            sendMessageModalVisible:false,
            arrayDefaultMessages:['I would like to buy this', 'Is this still available?'],
            saleitemId:'',
            theSaleItem:{},
            loadingPage:false,

        }
    },

    methods:{
        //Get sale item details, if direct link
        getSaleItemDetails(){
            this.loadingPage = true
            console.log("Getting sale item details")
            fb.forSaleCollection.doc(this.saleitemId).get().then(res => {
                var saleData = res.data()
                saleData.docId = res.id
                this.theSaleItem = saleData
                this.loadingPage = false
            }).catch(err => {
                this.loadingPage = false
                console.log(err)
            })
        },
    },

    mounted(){
        //If direct link
        if(this.$route.params.saleitemid ){
            console.log("saleitemid id = " + this.$route.params.saleitemid )
            this.saleitemId = this.$route.params.saleitemid 
            this.getSaleItemDetails()
        }

        //If not direct link, get item details from state
        else{
            this.theSaleItem = this.selectedSaleItem
        }
    },
}
</script>

